import { render, staticRenderFns } from "./Calculadora.vue?vue&type=template&id=14556222&scoped=true"
import script from "./Calculadora.vue?vue&type=script&lang=js"
export * from "./Calculadora.vue?vue&type=script&lang=js"
import style0 from "./Calculadora.vue?vue&type=style&index=0&id=14556222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14556222",
  null
  
)

export default component.exports